import React from 'react';
import { DishFirstExploreWidthLimit } from 'src/pages/consumer/dish-first/explore/components/SharedStyles';
import styled from 'styled-components';
import { BulkDiscountBanner } from './BulkDiscountBanner';
import { MiniGetItTomorrowBanner } from './GetItTomorrowBanners';
import { MiniReferralBanner } from './ReferralBanners';

type TopBannerRowProps = {
  regionId?: number;
};

const HorizontalScrollableWidthLimitContainer = styled(DishFirstExploreWidthLimit)`
  overflow-x: scroll;

  &::-webkit-scrollbar {
    -webkit-appearance: none;
    display: none;
  }
`;

export const TopBannerRow: React.FC<TopBannerRowProps> = () => (
  <HorizontalScrollableWidthLimitContainer className='mb-10 mt-2 flex gap-4 px-4 py-0 sm:-mt-4'>
    <MiniReferralBanner className='shrink-0 grow' />
    <BulkDiscountBanner className='shrink-0 grow' />
    <MiniGetItTomorrowBanner className='shrink-0 grow' />
  </HorizontalScrollableWidthLimitContainer>
);
